export const roleLevel = { developer_admin: 4, super_admin: 3, branch_manager: 2, teacher: 1, parent: 0 };

export const canManagePermissionsOf = (currentUser, target) =>
  (roleLevel[currentUser?.role] ?? 0) > (roleLevel[target?.role] ?? 0);
